/**
 *
 * @module tower
 * @author Shojib [Mahmud.Hossain@mlb.com]
 * @description Scores Collection eventTower (communication hub)
 *
 */

import util from 'util';
import assign from 'lodash-es/assign';
import size from 'lodash-es/size';
import EventEmitter from 'events';
import G5EventTower from 'g5-component/src/scripts/events/master';
import eventGroupExtender from './group/extender';

const VIDEO_PLAYER_ID_PREFIX_LENGTH = '#g5-component--mlb-scores__video--'.length;

class ScoresEventTower extends G5EventTower {

    constructor(master) {

        super(master);

        this.props = {
            instance: false
        };

        this.core = {
            scores: this.master,
            scoresModel: this.model,
            scoresViewModel: this.viewModel
        };

    }

    static hasEventEmitter(obj = {}) {

        return obj instanceof EventEmitter;

    }

    /**
     *
     * @method detachEvents
     * @param {Object} target
     * @description checks if a given target has events, proceeds to remove if true
     *
     */
    static detachEvents(target = {}) {

        const { hasEventEmitter } = ScoresEventTower;
        const hasEvents = hasEventEmitter(target) && size(target._events);

        if (hasEvents) {
            target.removeAllListeners();
        }

    }

    /**
     *
     * @method attachVideoEvents
     * @description Subscribe to messages from video embedder
     * Currently used to pause data updates when video is playing
     *
     */
    attachVideoEvents() {

        const scores = this.master;
        const scoresModel = this.model;
        const scoresViewModel = this.viewModel;
        const { opts } = scores;
        const { mode, videoEmbedder } = opts;

        if (mode === 'responsive' && videoEmbedder) {

            const eventBus = videoEmbedder.getEventBus();
            const events = videoEmbedder.getAvailableEvents();

            eventBus.on(events.COMPLETE, (container) => {

                const gamePk = container.substr(VIDEO_PLAYER_ID_PREFIX_LENGTH);
                scoresViewModel.emit('video-completed', gamePk);
                scores.emit('video-completed', gamePk);

            });

            eventBus.on(events.PAUSE, (container) => {

                const gamePk = container.substr(VIDEO_PLAYER_ID_PREFIX_LENGTH);
                scoresViewModel.emit('video-paused', gamePk);
                scores.emit('video-paused', gamePk);

            });

            eventBus.on(events.EMBED_PLAYER_READY, (container) => {

                const gamePk = container.substr(VIDEO_PLAYER_ID_PREFIX_LENGTH);
                scoresViewModel.emit('video-started', gamePk);
                scores.emit('video-started', gamePk);

            });

            eventBus.on(events.EMBED_USER_CLOSED, (container) => {

                const gamePk = container.substr(VIDEO_PLAYER_ID_PREFIX_LENGTH);
                scoresViewModel.emit('video-closed', gamePk);
                scores.emit('video-closed', gamePk);

            });

        }

    }

    /**
     *
     * @method attachEvents
     * @description attaches all primary events
     *
     */
    attachEvents() {

        const { master, model, viewModel } = this;
        const groupExt = eventGroupExtender(master, model, viewModel);

    }

    /**
     *
     * @method init
     * @description instantiates scores eventTower
     *
     */
    init() {

        const { props, core } = this;
        const { instance } = props;

        util.log('mlbScores eventTower - init');

        this.core = core;

        if (!instance) {

            props.instance = true;

            this.attachVideoEvents();

        }

    }

}

export default ScoresEventTower;
